import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return {
    response: response?.data?.childDetails ?? [],
    page: {
      size: response?.data?.page?.size,
      totalElements: response?.data?.page?.totalElements,
      totalPages: response?.data?.page?.totalPages,
      number: response?.data?.page?.number,
    },
  }
}

const fetchAllBeneficiariesList = (
  identificationNumber: string,
  type: string,
  tokens: any,
  pageNumber: number,
  recordsPerPage: number,
) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.allBeneficiariesList,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: sitConfig(tokens).headers,
    body: {
      identificationNumber: identificationNumber,
      type: type,
      configParams: {
        recordCount: recordsPerPage,
        page: pageNumber,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchAllBeneficiariesList }
